import { render, staticRenderFns } from "./DeviceWrapper.vue?vue&type=template&id=89f310aa&"
import script from "./DeviceWrapper.vue?vue&type=script&lang=js&"
export * from "./DeviceWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports